module.exports = __webpack_public_path__ + "static/media/shopping-bag.ff93a616.png";